import { render, staticRenderFns } from "./CardListRestaurantSidebar.vue?vue&type=template&id=70c7deb6&scoped=true&"
import script from "./CardListRestaurantSidebar.vue?vue&type=script&lang=js&"
export * from "./CardListRestaurantSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CardListRestaurantSidebar.vue?vue&type=style&index=0&id=70c7deb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c7deb6",
  null
  
)

export default component.exports